import { DataDropdown } from "capitalrx-components-2.0/lib/forms";
import { useRemoteTableDataSource } from "capitalrx-components-2.0/lib/general";

import { getApiBaseUrl } from "@/api";
import { FormElementBaseProps } from "@/api/interfaces";
import { useCallback, useMemo, useState } from "react";

interface MDDBDrug {
  ndc?: string | null;
  drug_name?: string | null;
  gpi?: string | null;
  dosage?: string | null;
  dosage_form?: string | null;
  package_size?: string | null;
  package_size_unit_of_measure?: string | null;
}

export const NDCDropdown = ({
  name = "ndc",
  label = "Drug",
  required = false,
  disabled = false,
  testId,
}: FormElementBaseProps) => {
  const apiBaseUrl = getApiBaseUrl();
  const [searchValue, setSearchValue] = useState("");

  const maxLength = 100;
  const ndcLabelProvider = useCallback((row: MDDBDrug) => {
    const drugName = row?.drug_name ?? "";
    const ndc = row?.ndc ? `${row?.ndc} - ` : "";
    const dosage = row?.dosage ? ` (${row?.dosage})` : "";
    const form = row?.dosage_form ? ` - ${row?.dosage_form}` : "";
    const truncatedName =
      drugName.length > maxLength ? drugName.slice(0, maxLength) + "..." : drugName;
    return `${ndc}${truncatedName}${dosage}${form}`;
  }, []);


  const dataSource = useRemoteTableDataSource<MDDBDrug>(
    `${apiBaseUrl}/mddb_drug/list`,
    (row: MDDBDrug) => row?.ndc ?? "",
    {
      pageSize: 15,
      idFilterName: "drug_name_or_ndc",
      authTokenRequired: false,
      enabled: searchValue.length >= 4,
    },
  );

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  const noOptionsMessage = useMemo(() => {
    if (searchValue.length < 4) {
      return "Start typing to see results";
    }

    if (searchValue.length >= 4) {
      return "No options";
    }

    return null;
  }, [searchValue]);


  return (
    <DataDropdown.Field
      dataSource={dataSource}
      optionLabelProvider={ndcLabelProvider}
      label={label}
      name={name}
      placeholder="Search"
      searchField="drug_name_or_ndc"
      disabled={disabled}
      required={required}
      testId={testId}
      onSearchChange={handleSearchChange}
      noOptionsMessage={noOptionsMessage}
    />
  );
};
